export default __webpack_public_path__ + "ca81e2d0791bcdde1537c781faa6001a.png";